module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8017.c815bfae.png";